export function ScorePill({ pct }) {
  const c = pct >= 80 ? "g" : pct >= 60 ? "m" : "l";
  return <span className={`score-pill ${c}`}>{pct}%</span>;
}

export function MiniBars({ sessions }) {
  if (!sessions.length) return null;
  return (
    <div className="mini-bars">
      {sessions.map((s, i) => (
        <div key={i} className="mini-bar" style={{ height: `${Math.max(s.score, 6)}%`, background: s.score >= 80 ? "var(--green)" : s.score >= 60 ? "var(--amber)" : "var(--red)", opacity: .55 + i * .06 }} />
      ))}
    </div>
  );
}
